// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__2QQ3s","checkboxCol":"Table_checkboxCol__288fz","emailCol":"Table_emailCol__3LoF4","actionCol":"Table_actionCol__1hzkD"};